import React from "react";
import ArchiveTable from "../../../Components/FeedComponents/ArchiveTable/ArchiveTable";
import PageContainer from "../../Shared/PageContainer/PageContainer";

const Archives = () => {
  return (
    <>
      <PageContainer pt={"50px"} title="Archives">
        <div style={{ height: "100vh", width: "100%" }}>
          <ArchiveTable />
        </div>
      </PageContainer>
    </>
  );
};

export default Archives; 